import { useDashboardConfig } from './useDashboardContext';
export const useAppName = () => {
    const config = useDashboardConfig();
    const { APP_ID } = config;
    const appIdToNameMap = { '5ea01123a74e10da5fa35e82': 'FEED', '56d5748b094d7cfd49b36534': 'DASHBOARD' };
    return appIdToNameMap[APP_ID];
};
//# sourceMappingURL=useAppName.js.map